import { Grid, Typography } from '@mui/material';
import { StripedDataGrid } from 'views/backoffice/CustomLists/components';
import { CustomGridToolbar } from '../CustomGridToolbar';
import { GridApiPro, GridColDef, GridRowParams } from '@mui/x-data-grid-pro';
import { FooterWithPagination } from 'ui-component/grids/components';
import { IRecordHeaders } from 'ui-component/records/types';

export type PreviewGridSectionProps = {
    rows: any[];
    columns: GridColDef[];
    selectedRows: (string | number)[];
    onChangeSelectedRows: (rows: (string | number)[]) => void;
    onUpdateRow: (newRow: any) => any;
    apiRef?: React.MutableRefObject<GridApiPro>;
    getDetailPanelContent?: ((params: GridRowParams<IRecordHeaders>) => React.ReactNode) | undefined;
    getDetailPanelHeight?: ((params: GridRowParams) => number | 'auto') | undefined;
    isImportRecordAndObjectPanelOpened?: boolean;
};

export const PreviewGridSection = ({
    rows,
    columns,
    selectedRows,
    onChangeSelectedRows,
    onUpdateRow,
    apiRef,
    getDetailPanelContent,
    getDetailPanelHeight,
    isImportRecordAndObjectPanelOpened
}: PreviewGridSectionProps) => (
    <Grid
        item
        xs="auto"
        sx={{ px: '24px', py: '12px', width: `calc(100% - 180px${isImportRecordAndObjectPanelOpened ? ' - 405px' : ''}) !important` }}
    >
        <>
            <Typography fontSize="20px" fontWeight={700} color="secondary">
                Preview
            </Typography>
            <StripedDataGrid
                apiRef={apiRef}
                rows={rows}
                density="compact"
                sx={{
                    height: 'calc(100% - 27px)',
                    '.MuiDataGrid-columnHeaders': { background: 'white' },
                    '.MuiDataGrid-columnHeaderTitleContainer': { fontSize: '16px', fontWeight: 700 }
                }}
                initialState={{ pinnedColumns: { right: ['actions'] } }}
                slots={{
                    toolbar: CustomGridToolbar,
                    footer: FooterWithPagination
                }}
                editMode="row"
                onRowEditStart={(params, event) => {
                    if (params.reason && params.reason === 'cellDoubleClick') {
                        event.defaultMuiPrevented = true;
                    }
                }}
                processRowUpdate={(newRow) => {
                    onUpdateRow(newRow);
                    return newRow;
                }}
                checkboxSelection
                onRowSelectionModelChange={(newSelection) => onChangeSelectedRows(newSelection)}
                rowSelectionModel={selectedRows}
                columns={columns}
                getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd')}
                disableRowSelectionOnClick
                {...(getDetailPanelContent && { getDetailPanelContent, getDetailPanelHeight })}
            />
        </>
    </Grid>
);
